import React from 'react';
// import siteVisitBanner from '../../assets/plus_icon/siteVisitBanner.png'
import siteVisitBanner from '../../assets/plus_icon/reves_banner.png'

const Banner = ({ }) => {
    return (
        <div className={`relative`}>
            <img src={siteVisitBanner} alt="" className=' sm:aspect-[16/5] xl:aspect-[16/4.5] !rounded-lg' />
            <div className='absolute top-4 sm:top-10 left-0 bg-gradient-to-r from-[#344054]/100 to-[#66666600] w-[150px] sm:w-[253px]'>
                <div className='text-white text-xs sm:text-lg font-semibold py-1 pl-1 sm:!py-3 sm:!pl-3'>
                    Divine Reves
                </div>
            </div>
        </div>
    )
}

export default Banner